<!-- Nota tabsList are not being passed till cashflow tab is made -->
<template>
    <widget-wrapper
    class="cashflow-patrimony"
    :extraClass="selectedTab === 'patrimony' ? 'visible-overflow' : null"
    :underDevelopment="selectedTab === 'cashflow'"
    :variant="variant"
    :applyErrorState="applyErrorState"
    :title="t('home.widgets.patrimony.title')"
    @tabClicked="tabClickHandler"
    @redirectToFeature="redirectToFeatureHandler">
        <!-- <cashflow-tab-content
        v-if="selectedTab === 'cashflow'"
        :showPatrimonyLoader="showPatrimonyLoader"
        :variant="variant"
        @applyCashflowErrorState="applyErrorState = $event"/> -->

        <patrimony-tab-content
        v-if="selectedTab === 'patrimony'"
        :simplifiedVersion="simplifiedVersion"
        :showPatrimonyLoader="showPatrimonyLoader"
        :hideAmounts="hideAmounts"
        :variant="variant"/>
    </widget-wrapper>
</template>

<script setup>
import WidgetWrapper from '@/components/features/home/WidgetWrapper'
import CashflowTabContent from '@/components/features/home/widgets/CashflowTabContent'
import PatrimonyTabContent from '@/components/features/home/widgets/PatrimonyTabContent'
/* Vue & Assets */
import { ref, computed, watch, onBeforeUnmount } from 'vue'
import { navigateByName } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'
/* Store */
import { mapActions } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Props
@simplifiedVersion {Boolean} - prop to apply simplified version
@showPatrimonyLoader {Boolean} - prop to tell widget patrimony fetch state
@applyPatrimonyErrorState {Boolean} - prop to tell widget patrimony fetch state
@variant {String} - can be [ none (default), anchor]
*/
const props = defineProps({
    simplifiedVersion: Boolean,
    showPatrimonyLoader: Boolean,
    applyPatrimonyErrorState: Boolean,
    hideAmounts: Boolean,
    variant: String
})

/* mapActions */
const { clearFeatureStates } = mapActions(moduleMapper.HOME)

/* Data */
const applyErrorState = ref(false)

/*************************************************
*                                                *
*                    Tabs Logic                  *
*                                                *
*************************************************/
const tabsList = ref([{
    id: 'cashflow',
    label: t('home.widgets.cashflow.title'),
    selected: false
},
{
    id: 'patrimony',
    label: t('home.widgets.patrimony.title'),
    selected: true
}])

const tabClickHandler = $event => {
    tabsList.value.forEach(tab => {
        tab.selected = tab.id === $event
    })
}

const selectedTab = computed(() => {
    return tabsList.value.find(obj => obj.selected).id
})

watch(() => props.applyPatrimonyErrorState, (newVal, oldVal) => {
    if (props.applyPatrimonyErrorState) applyErrorState.value = true
})

const redirectToFeatureHandler = () => {
    selectedTab.value === 'cashflow' ? navigateByName(routeList.ACCOUNTS_CASHFLOW_NAME) : navigateByName(routeList.ACCOUNTS_PATRIMONY_NAME)
}

onBeforeUnmount(() => {
	clearFeatureStates()
})
</script>

<style lang="scss" scoped>
</style>
